import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 查询")
const _hoisted_3 = { style: {"margin-bottom":"20px","text-align":"right"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增角色")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("管理员")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("用户")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_9 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 菜单权限 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 删除角色 ")

import { reactive, ref, unref, onMounted } from 'vue';
import { ElButton, ElTag } from 'element-plus';
import { GbTables } from '@/components/GbTables';
import { RoleDialog, AuthorityDialog } from './components/Index';
import { useGbTable } from '@/hooks/useGbTable';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { DeleteRoleDto, RoleListDto } from '../../../apis/basics/roles/dto';
import { DeleteRoleApi, GetRoleListApi } from '../../../apis/basics/roles/api';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const writerRef = ref<ComponentRef<typeof RoleDialog>>();
const authorityRef = ref<ComponentRef<typeof AuthorityDialog>>();

const state = reactive({
	loading: false,
	search: {} as any,
	paged: { current: 1, page_size: 20 },
});

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<RoleListDto>({
	getListApi: GetRoleListApi,
	delListApi: DeleteRoleApi,
	response: { data: 'data', total: 'total' },
});

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'code', label: '编号', columnWidth: '150' },
	{ field: 'name', label: '角色名称', columnWidth: '120' },
	{ field: 'remark', label: '备注' },
	{ field: 'is_admin', label: '是否管理员', columnWidth: '100', align: 'center' },
	{ field: 'is_enabled', label: '是否启用', columnWidth: '100', align: 'center' },
	{ field: 'sort', label: '排序', columnWidth: '60', align: 'center' },
	{ field: 'created_time', label: '创建时间', columnWidth: '120', fixed: 'right' },
	{ field: 'action', width: '120px', label: '操作', fixed: 'right', align: 'center' },
]);

/* 按钮操作 */
const actions = {
	search: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
	reSetSearch: () => {
		state.search = {};
		methods.resetParams(state.search);
	},
	/* 创建角色 */
	create: () => {
		unref(writerRef)?.showDialog('', false);
	},

	/* 修改角色 */
	modify: (rowId: string) => {
		unref(writerRef)?.showDialog(rowId, true);
	},

	/* 删除角色 */
	deletes: async (row: any) => {
		const deleteData: DeleteRoleDto = { id: row.id, revision: row.revision };
		await methods.deleteRows(deleteData);
	},

	/* 菜单权限设置 */
	authorityCfg: (row: any) => {
		unref(authorityRef)?.showDialog(row.id, row.name);
	},
};

onMounted(async () => {
	tableObject.pageSize = 20;
	actions.search();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).search,
          type: "small",
          inline: true,
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "角色编号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.code) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "角色名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSetSearch
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      icon: "Search",
                      onClick: actions.search
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(ElButton), {
            size: "small",
            type: "primary",
            onClick: actions.create
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY/MM/DD HH:mm')), 1)
          ]),
          is_admin: _withCtx(({ row }) => [
            (row.is_admin == 'Y')
              ? (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 1,
                  type: "warning",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
          ]),
          is_enabled: _withCtx(({ row }) => [
            (row.is_enabled == 'Y')
              ? (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 1,
                  type: "warning",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
          ]),
          action: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(ElButton), {
                size: "small",
                type: "success",
                link: "",
                onClick: ($event: any) => (actions.modify(row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_dropdown, {
                style: {"padding":"2px","margin-left":"12px"},
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            type: "info",
                            link: "",
                            onClick: ($event: any) => (actions.authorityCfg(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            type: "danger",
                            link: "",
                            onClick: ($event: any) => (actions.deletes(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_More)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }),
    _createVNode(_unref(RoleDialog), {
      ref_key: "writerRef",
      ref: writerRef,
      onRefresh: actions.search
    }, null, 8, ["onRefresh"]),
    _createVNode(_unref(AuthorityDialog), {
      ref_key: "authorityRef",
      ref: authorityRef
    }, null, 512)
  ], 64))
}
}

})